import { cn } from '@shared/cove-ui';
import { forwardRef, HTMLAttributes } from 'react';

const H4 = forwardRef<HTMLHeadingElement, HTMLAttributes<HTMLHeadingElement>>(
  ({ className, children, ...props }, ref) => {
    return (
      <h4 className={cn('text-h4', className)} {...props} ref={ref}>
        {children}
      </h4>
    );
  }
);

export default H4;
